import { render, staticRenderFns } from "./VBadge.vue?vue&type=template&id=0f8174aa&scoped=true"
import script from "./VBadge.vue?vue&type=script&lang=js"
export * from "./VBadge.vue?vue&type=script&lang=js"
import style0 from "./VBadge.vue?vue&type=style&index=0&id=0f8174aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8174aa",
  null
  
)

export default component.exports